<template>
  <div class="tebodyitem">
    <div class="tebodyitem-header"><span>配置内容</span></div>
  </div>
  <div class="tebodyitem">
    <el-form-item label="订舱编号命名前缀" required>
      <el-input v-model="form.bookingNoPrefix" clearable placeholder="请输入" />
    </el-form-item>
  </div>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';

  const emits = defineEmits([ 'change' ]);

  const props = defineProps({
    data: {
      type: Object,
      default: null
    }
  });

  const form = ref({})
  watch(() => form.value, () => {
    emits('change', form.value)
  }, { deep: true });

  const init = () => {
    form.value.bookingNoPrefix = props.data.bookingNoPrefix
  }
  watch(() => props.data, () => {
    init();
  }, { deep: true });
</script>

<style scoped lang="less">
  @import "./index.less";
</style>